// extracted by mini-css-extract-plugin
export default {"a1":"Contact_a1__yRecq","a2":"Contact_a2__P8wJ+","section":"Contact_section__4GVTu","pp":"Contact_pp__IY-a8"};